import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { EMPTY, of } from 'rxjs';
import { tap, debounceTime, distinctUntilChanged, filter, flatMap, catchError, take, map } from 'rxjs/operators';
import { AccountService, HeadsetSearchResponse } from '../account.service';
import { Account } from '../models/account';
import { Headset } from '../models/headset';

@Component({
  selector: 'app-headset-search',
  templateUrl: './headset-search.component.html',
  styleUrls: ['./headset-search.component.css']
})
export class HeadsetSearchComponent implements OnInit {
  // @Output() accSelected: EventEmitter<any> = new EventEmitter<any>();

  formGroup: FormGroup;
  // accountsList: string[] = [];
  accounts: Account[] = [];
  accountsList: HeadsetSearchResponse[] = [];
  loading = false;

  selectedAccount: Account;
  headsets: Headset[] = [];

  constructor(
    private _fb: FormBuilder,
    private accountService: AccountService,
    private snackbar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.createForm();
    this.setupAccountFilter();
    this.accountService.accounts$.pipe(
      take(1),
      map(x => {
        this.accounts = x;
      }),
    ).subscribe();
  }

  createForm() {
    this.formGroup = this._fb.group({
      serial: [''],
    });
  }

  setupAccountFilter() {
    const control = this.formGroup.get('serial');
    control.valueChanges
      .pipe(
        tap(() => this.accountsList = []),
        debounceTime(250),
        distinctUntilChanged(),
        filter(Boolean), // gets rid of blanks
        flatMap((val: string) => {
          this.loading = true;
          return this.accountService.searchHeadsets(val).pipe(
            catchError(err => {
              if (err instanceof HttpErrorResponse && err.status === 404) {
                // do nothing
              } else {
                console.error('could not search for headset');
                this.snackbar.open('Something went wrong - could not search for headset', 'OK');
              }
              this.loading = false;
              return of(null);
            }),
          );
        }),
      )
      .subscribe((data: HeadsetSearchResponse | null) => {
        this.loading = false;
        if (data) {
          this.accountsList = [data];
        }
      });
  }

  displayFnAccount(val: any) {
    return val.email;
  }

  selectHeadset(option) {
    console.log(option);
    console.log(option.option.value);
    this.formGroup.get('serial').setValue('');
    this.headsets = [option.option.value as HeadsetSearchResponse].map(x => x.hardware);
    // this.accSelected.emit(option.option.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/headset-search/headset-search.component.ts